import type { BlobLike } from "@pdfking/compatibility"
import type { CompletePage } from "../geometry/Page"
import type { PlottingContext } from "../options/PlottingContext"

export type PDFPlotFunction = (
  pages: CompletePage[],
  context: PlottingContext<Promise<BlobLike>>
) => AsyncGenerator<BlobLike>
